const columns = {
  provider_id: ['Provider ID', 'รหัสผู้ให้บริการ'],
  provider_name: ['Provider', 'ผู้ให้บริการ'],
  trip_id: ['Trip ID', 'รหัสเที่ยวบริการ'],
  trip_ref: ['Trip reference', 'เลขอ้างอิงเที่ยวบริการ'],
  booking_id: ['Booking ID', 'รหัสการจอง'],
  trip_status: ['Current trip status', 'สถานะเที่ยวบริการปัจจุบัน'],
  trip_leg: ['Trip leg', 'ขาเที่ยวบริการ'],
  service_mode: ['Service mode', 'รูปแบบบริการ'],
  dispatch_mode: ['Trip dispatch mode', 'รูปแบบจัดงานของเที่ยวบริการ'],
  created_at: ['Created at', 'สร้างเมื่อ'],
  service_date: ['Service date', 'วันเวลาบริการ'],
  service_date_basis: ['Service date source', 'แหล่งวันเวลาบริการ'],
  scheduled_start: ['Scheduled start', 'เวลาเริ่มตามนัด'],
  scheduled_end: ['Scheduled end', 'เวลาสิ้นสุดตามนัด'],
  pickup_appt_at: ['Pickup appointment', 'เวลานัดรับ'],
  arrive_by_at: ['Arrival deadline', 'เวลาที่ต้องถึง'],
  failure_event_id: ['Failure event ID', 'รหัสเหตุการณ์จัดงานล้มเหลว'],
  failed_at: ['Terminal failure time', 'เวลาล้มเหลวสิ้นสุด'],
  date_basis: ['Failure date source', 'แหล่งเวลาล้มเหลว'],
  dispatch_failed_at: ['Persisted dispatch failure time', 'เวลาจัดงานล้มเหลวที่บันทึกในเที่ยวบริการ'],
  failure_actor_type: ['Failure actor type', 'ประเภทผู้กระทำเหตุการณ์ล้มเหลว'],
  failure_actor_id: ['Failure actor ID', 'รหัสผู้กระทำเหตุการณ์ล้มเหลว'],
  failure_actor_name: ['Failure actor name at event', 'ชื่อผู้กระทำ ณ เหตุการณ์ล้มเหลว'],
  failure_reason_code: ['Persisted failure reason code', 'รหัสเหตุผลล้มเหลวที่บันทึก'],
  failure_reason_id: ['Failure reason ID', 'รหัสเหตุผลล้มเหลว'],
  failure_note: ['Failure note', 'หมายเหตุล้มเหลว'],
  staffing_deadline_at: ['Staffing deadline', 'กำหนดจัดพนักงาน'],
  latest_search_id: ['Associated search ID', 'รหัสการค้นหาที่สัมพันธ์'],
  latest_search_state: ['Associated search current state', 'สถานะปัจจุบันของการค้นหาที่สัมพันธ์'],
  latest_search_mode: ['Associated search mode', 'รูปแบบการค้นหาที่สัมพันธ์'],
  latest_search_strategy: ['Associated search strategy', 'กลยุทธ์การค้นหาที่สัมพันธ์'],
  latest_attempt_id: ['Latest eligible attempt ID', 'รหัสการประเมินล่าสุดที่เกี่ยวข้อง'],
  latest_attempt_revision: ['Latest eligible attempt revision', 'รุ่นการประเมินล่าสุดที่เกี่ยวข้อง'],
  latest_offer_id: ['Latest eligible offer ID', 'รหัสข้อเสนองานล่าสุดที่เกี่ยวข้อง'],
  latest_offer_kind: ['Latest eligible offer kind', 'ประเภทข้อเสนองานล่าสุดที่เกี่ยวข้อง'],
  latest_offer_status: ['Latest eligible offer current state', 'สถานะปัจจุบันของข้อเสนองานล่าสุดที่เกี่ยวข้อง'],
  latest_offer_offered_at: ['Latest eligible offer time', 'เวลาเสนอของข้อเสนองานล่าสุดที่เกี่ยวข้อง'],
  latest_offer_responded_at: ['Latest eligible offer response time', 'เวลาตอบของข้อเสนองานล่าสุดที่เกี่ยวข้อง'],
  dispatch_evidence_state: ['Dispatch evidence coverage', 'ความครอบคลุมหลักฐานจัดงาน'],
  search_association: ['Search association provenance', 'ที่มาความสัมพันธ์การค้นหา'],
  failure_date_mismatch: ['Failure timestamps differ', 'เวลาล้มเหลวสองแหล่งไม่ตรงกัน'],
  passenger_id: ['Passenger ID', 'รหัสผู้โดยสาร'],
  passenger_code: ['Passenger code', 'รหัสประจำตัวผู้โดยสาร'],
  passenger_name: ['Passenger', 'ผู้โดยสาร'],
  passenger_phone: ['Passenger phone', 'โทรศัพท์ผู้โดยสาร'],
  agent_id: ['Assigned agent ID', 'รหัสพนักงานที่ได้รับมอบหมาย'],
  agent_code: ['Assigned agent code', 'รหัสประจำตัวพนักงานที่ได้รับมอบหมาย'],
  agent_name: ['Assigned agent', 'พนักงานที่ได้รับมอบหมาย'],
  agent_phone: ['Assigned agent phone', 'โทรศัพท์พนักงานที่ได้รับมอบหมาย'],
  vehicle_id: ['Vehicle ID', 'รหัสรถ'],
  vehicle_plate: ['Vehicle plate', 'ทะเบียนรถ'],
  service_area_ids: ['Current service area IDs', 'รหัสพื้นที่บริการปัจจุบัน'],
  service_area_names: ['Current service areas', 'พื้นที่บริการปัจจุบัน'],
  service_group_id: ['Service group ID', 'รหัสกลุ่มบริการ'],
  service_group_name: ['Service group', 'กลุ่มบริการ'],
  scope_provenance: ['Service scope source', 'แหล่งขอบเขตบริการ'],
  origin_label: ['Origin', 'ต้นทาง'],
  destination_label: ['Destination', 'ปลายทาง'],
  currency: ['Currency', 'สกุลเงิน'],
  fare_state: ['Fare evidence state', 'สถานะหลักฐานค่าโดยสาร'],
  quote_provenance: ['Quote source', 'แหล่งราคาประเมิน'],
  quoted_total: ['Quoted total', 'ยอดราคาประเมิน'],
  current_total: ['Persisted fare total', 'ยอดค่าโดยสารที่บันทึก'],
  final_total: ['Final total', 'ยอดสุดท้าย'],
  fare_adjustment_delta: ['Fare adjustment', 'ส่วนต่างค่าโดยสาร'],
  fare_base: ['Base fare', 'ค่าโดยสารพื้นฐาน'],
  fare_overage_distance: ['Distance overage fare', 'ค่าโดยสารระยะทางเกิน'],
  fare_overage_time: ['Time overage fare', 'ค่าโดยสารเวลาเกิน'],
  fare_surcharge_total: ['Surcharge total', 'ยอดค่าเพิ่ม'],
  fare_computed_at: ['Fare computed at', 'คำนวณค่าโดยสารเมื่อ'],
  billing_distance_source: ['Billing distance source', 'แหล่งระยะทางคิดเงิน'],
  billing_duration_source: ['Billing duration source', 'แหล่งเวลาคิดเงิน'],
  billable_distance_km: ['Billable distance (km)', 'ระยะทางคิดเงิน (กม.)'],
  billable_duration_min: ['Billable duration (minutes)', 'ระยะเวลาคิดเงิน (นาที)'],
  fare_is_free: ['Free service flag', 'สถานะบริการฟรี'],
  base_payment_status: ['Base payment status', 'สถานะชำระเงินพื้นฐาน'],
  base_amount_due: ['Base amount due', 'ยอดเรียกเก็บพื้นฐาน'],
  base_amount_received: ['Base amount received', 'ยอดรับพื้นฐาน'],
  base_outstanding: ['Base outstanding', 'ยอดค้างพื้นฐาน'],
  base_due_by: ['Base payment deadline', 'กำหนดชำระพื้นฐาน'],
  base_verified_at: ['Base verified at', 'ยืนยันชำระพื้นฐานเมื่อ'],
  overage_payment_status: ['Overage payment status', 'สถานะชำระส่วนเกิน'],
  overage_amount_due: ['Overage amount due', 'ยอดเรียกเก็บส่วนเกิน'],
  overage_amount_received: ['Overage amount received', 'ยอดรับส่วนเกิน'],
  overage_outstanding: ['Overage outstanding', 'ยอดค้างส่วนเกิน'],
  overage_due_by: ['Overage payment deadline', 'กำหนดชำระส่วนเกิน'],
  overage_verified_at: ['Overage verified at', 'ยืนยันชำระส่วนเกินเมื่อ'],
  billed_total: ['Customer billed total', 'ยอดเรียกเก็บลูกค้า'],
  received_total: ['Customer receipts retained', 'ยอดรับลูกค้าที่คงบันทึก'],
  outstanding_total: ['Customer outstanding total', 'ยอดค้างลูกค้า'],
  payment_state: ['Customer payment state', 'สถานะการชำระลูกค้า'],
  requires_finance_review: ['Requires finance review', 'ต้องตรวจสอบการเงิน'],
} as const;
const filters = {
  failureReason: ['Failure reason code (UNKNOWN for unavailable)', 'รหัสเหตุผลล้มเหลว (UNKNOWN เมื่อไม่มีข้อมูล)'],
  latestSearchMode: ['Associated search mode', 'รูปแบบการค้นหาที่สัมพันธ์'],
  latestSearchStrategy: ['Associated search strategy', 'กลยุทธ์การค้นหาที่สัมพันธ์'],
  latestSearchState: ['Associated search state', 'สถานะการค้นหาที่สัมพันธ์'],
  latestOfferState: ['Latest eligible offer state', 'สถานะข้อเสนองานล่าสุดที่เกี่ยวข้อง'],
  evidenceState: ['Dispatch evidence coverage', 'ความครอบคลุมหลักฐานจัดงาน'],
  hasStaffingDeadline: ['Has staffing deadline', 'มีกำหนดจัดพนักงาน'],
  missingEvent: ['Missing terminal failure event', 'ไม่มีเหตุการณ์ล้มเหลวสิ้นสุด'],
  serviceMode: ['Service mode', 'รูปแบบบริการ'],
  passengerId: ['Passenger ID', 'รหัสผู้โดยสาร'],
  agentId: ['Assigned agent ID', 'รหัสพนักงานที่ได้รับมอบหมาย'],
  paymentState: ['Customer payment state', 'สถานะการชำระลูกค้า'],
  requiresFinanceReview: ['Requires finance review', 'ต้องตรวจสอบการเงิน'],
} as const;
const summary = {
  missedTripCount: ['Missed trips', 'เที่ยวบริการที่พลาด'],
  fareTotalSum: ['Persisted fare total', 'รวมค่าโดยสารที่บันทึก'],
  billedTotalSum: ['Customer billed total', 'รวมยอดเรียกเก็บลูกค้า'],
  receivedTotalSum: ['Customer receipts retained', 'รวมยอดรับลูกค้าที่คงบันทึก'],
  outstandingTotalSum: ['Customer outstanding total', 'รวมยอดค้างลูกค้า'],
  freeTripCount: ['Free payment-state trips', 'เที่ยวบริการสถานะชำระฟรี'],
  financeReviewCount: ['Finance review trips', 'เที่ยวบริการต้องตรวจสอบการเงิน'],
  missingFareCount: ['Trips with unavailable fare', 'เที่ยวบริการไม่มีค่าโดยสาร'],
  missingFailureDateCount: ['Unavailable failure date', 'ไม่มีเวลาล้มเหลว'],
  missingEventCount: ['Missing failure event', 'ไม่มีเหตุการณ์ล้มเหลว'],
  missingLinkedSearchCount: ['No associated search', 'ไม่มีการค้นหาที่สัมพันธ์'],
  expiredEvidenceCount: ['Expired dispatch evidence', 'หลักฐานจัดงานหมดอายุ'],
  failureDateMismatchCount: ['Failure date mismatches', 'เวลาล้มเหลวไม่ตรงกัน'],
  unknownReasonCount: ['Unavailable failure reason', 'ไม่มีเหตุผลล้มเหลว'],
} as const;
const values = {
  TERMINAL_FAILURE_EVENT: ['Terminal failure event', 'เหตุการณ์ล้มเหลวสิ้นสุด'],
  DISPATCH_FAILED_AT: ['Trip dispatch-failed timestamp fallback', 'ใช้เวลาจัดงานล้มเหลวในเที่ยวบริการแทน'],
  UNAVAILABLE: ['Unavailable', 'ไม่มีข้อมูล'],
  SCHEDULED_START: ['Scheduled start', 'เวลาเริ่มตามนัด'],
  CREATED_AT_FALLBACK: ['Created-time fallback', 'ใช้เวลาสร้างแทน'],
  CURRENT_SERVICE_GROUP: ['Current service-group mapping', 'พื้นที่จากกลุ่มบริการปัจจุบัน'],
  LINKED_SEARCH: ['Explicit event-linked search', 'การค้นหาที่เหตุการณ์ระบุโดยตรง'],
  TEMPORAL_ASSOCIATION: [
    'Latest search started by failure time (association only)',
    'การค้นหาล่าสุดที่เริ่มก่อนเวลาล้มเหลว (สัมพันธ์ตามเวลาเท่านั้น)',
  ],
  LATEST_AVAILABLE: ['Latest available history; cause not established', 'ประวัติล่าสุดที่มี ไม่ยืนยันสาเหตุ'],
  EXPIRED: ['Detailed evidence expired; persisted facts retained', 'หลักฐานรายละเอียดหมดอายุ คงข้อเท็จจริงที่บันทึก'],
  AUTO: ['Automatic', 'อัตโนมัติ'],
  MANUAL: ['Manual', 'จัดด้วยเจ้าหน้าที่'],
  SEQUENTIAL: ['Sequential', 'ตามลำดับ'],
  BROADCAST: ['Broadcast', 'กระจายข้อเสนองาน'],
  ACTIVE: ['Active', 'กำลังดำเนินการ'],
  ASSIGNED: ['Assigned', 'มอบหมายแล้ว'],
  EXHAUSTED: ['Search exhausted', 'ค้นหาจนครบ'],
  CANCELLED: ['Cancelled', 'ยกเลิก'],
  SUPERSEDED: ['Superseded', 'ถูกแทนที่'],
  LEGACY_HISTORY: ['Legacy history', 'ประวัติเดิม'],
  PENDING: ['Pending', 'รอตอบ'],
  ACCEPTED: ['Accepted', 'รับงาน'],
  REJECTED: ['Rejected', 'ปฏิเสธ'],
  EXPIRED_OFFER: ['Offer expired', 'ข้อเสนองานหมดอายุ'],
  AUTO_INITIAL: ['Initial automatic offer', 'ข้อเสนออัตโนมัติครั้งแรก'],
  MANUAL_INITIAL: ['Initial manual offer', 'ข้อเสนอจัดงานครั้งแรก'],
  MANUAL_REASSIGNMENT: ['Manual reassignment offer', 'ข้อเสนอมอบหมายใหม่'],
  SYSTEM: ['System', 'ระบบ'],
  PASSENGER: ['Passenger', 'ผู้โดยสาร'],
  AGENT: ['Agent', 'พนักงาน'],
  ORG_USER: ['Operator', 'เจ้าหน้าที่'],
  NONE: ['No fare evidence', 'ไม่มีหลักฐานค่าโดยสาร'],
  PROVISIONAL: ['Provisional persisted fare', 'ค่าโดยสารชั่วคราวที่บันทึก'],
  FINAL: ['Final fare evidence', 'หลักฐานค่าโดยสารสุดท้าย'],
  CANCELLED_SNAPSHOT: ['Terminal fare snapshot', 'ภาพค่าโดยสาร ณ สถานะสิ้นสุด'],
  BOOKING_SNAPSHOT: ['Immutable booking quote', 'ราคาประเมิน ณ การจองที่ไม่แก้ย้อนหลัง'],
  FREE: ['Free', 'ฟรี'],
  FINANCE_REVIEW: ['Finance review', 'ตรวจสอบการเงิน'],
  NOT_BILLABLE: ['Not billable', 'ไม่เรียกเก็บ'],
  UNBILLED: ['Unbilled', 'ยังไม่เรียกเก็บ'],
  OUTSTANDING: ['Outstanding', 'ค้างชำระ'],
  PARTIAL: ['Partially received', 'รับเงินบางส่วน'],
  SETTLED: ['Settled', 'ชำระครบ'],
  PENDING_SLIP: ['Awaiting transfer slip', 'รอหลักฐานโอน'],
  SLIP_SUBMITTED: ['Slip submitted', 'ส่งหลักฐานโอนแล้ว'],
  VERIFIED: ['Verified', 'ยืนยันแล้ว'],
  WAIVED: ['Waived', 'ยกเว้น'],
  REFUND_PENDING: ['Refund pending', 'รอคืนเงิน'],
  REFUNDED: ['Refund recorded', 'บันทึกคืนเงินแล้ว'],
  RIDE_AND_CARE: ['Ride and care', 'รับส่งพร้อมดูแล'],
  CARE: ['Care', 'ดูแล'],
  RIDE: ['Ride', 'รับส่ง'],
  TRAVEL: ['Travel', 'เดินทาง'],
  MISSED: ['Missed', 'พลาดบริการ'],
  OUTBOUND: ['Outbound', 'ขาไป'],
  RETURN: ['Return', 'ขากลับ'],
  STATUS_EVENTS: ['Status-event measurements', 'การวัดจากเหตุการณ์สถานะ'],
  GPS_TRACE: ['GPS trace', 'เส้นทาง GPS'],
  UNKNOWN: ['Unknown', 'ไม่ทราบ'],
  PLANNED_FALLBACK: ['Planned billing fallback', 'ใช้แผนเดิมคิดเงินแทน'],
} as const;
const messages = {
  title: ['Missed services', 'บริการที่พลาด'],
  reasonBreakdown: ['Missed trips — reason: {{value}}', 'เที่ยวบริการที่พลาด — เหตุผล: {{value}}'],
  coverage_missingFailureDate: [
    'Undated MISSED trips matching all other filters (not included in finite-range totals)',
    'เที่ยว MISSED ไม่มีเวลาล้มเหลวที่ตรงตัวกรองอื่นทั้งหมด (ไม่รวมในยอดช่วงเวลาจำกัด)',
  ],
  description: [
    'One row per currently MISSED trip, with persisted terminal failure and dispatch history. Cancelled, no-show and overdue active trips are excluded. Search exhaustion alone is not a missed service.',
    'หนึ่งแถวต่อเที่ยวบริการสถานะ MISSED ปัจจุบัน พร้อมเหตุการณ์ล้มเหลวสิ้นสุดและประวัติจัดงานที่บันทึก ไม่รวมยกเลิก ไม่มา หรือเที่ยวที่ยังดำเนินการแต่เลยเวลา การค้นหาจนครบอย่างเดียวไม่ถือว่าพลาดบริการ',
  ],
  dateBasis: [
    'Terminal failure time: latest DISPATCH_FAILED event, then trip dispatchFailedAt. All-time includes undated missed trips; finite ranges exclude unavailable timestamps.',
    'เวลาล้มเหลวสิ้นสุด: เหตุการณ์ DISPATCH_FAILED ล่าสุด แล้วจึงใช้ dispatchFailedAt ของเที่ยวบริการ ช่วงทั้งหมดรวมเที่ยวที่ไม่มีเวลา แต่ช่วงจำกัดไม่รวมเวลาที่ไม่มีข้อมูล',
  ],
  meaning_failedAt: [
    'Latest DISPATCH_FAILED event time is primary; dispatchFailedAt is a distinct preserved fallback. Exhausted search time is never substituted. Undated rows belong only to all-time.',
    'เวลาของ DISPATCH_FAILED ล่าสุดเป็นหลัก dispatchFailedAt เป็นแหล่งสำรองที่คงไว้แยก ไม่ใช้เวลาค้นหาจนครบแทน แถวไม่มีเวลาอยู่เฉพาะช่วงทั้งหมด',
  ],
  meaning_mismatch: [
    'True only when both event and dispatchFailedAt exist and differ; event time still wins.',
    'จริงเฉพาะเมื่อมีทั้งเวลาเหตุการณ์และ dispatchFailedAt แต่ต่างกัน ยังคงใช้เวลาเหตุการณ์เป็นหลัก',
  ],
  meaning_serviceDate: [
    'Service cohort time is scheduled start, falling back to creation; it is not the terminal-failure date used to filter this report.',
    'วันเวลาของกลุ่มบริการใช้เวลานัดเริ่มหรือเวลาสร้างเมื่อไม่มี ไม่ใช่เวลาล้มเหลวสิ้นสุดที่ใช้กรองรายงานนี้',
  ],
  meaning_evidence: [
    'Explicit event links take precedence over temporal association. LATEST_AVAILABLE is history without an available failure date, never an established cause. EXPIRED describes retained IDs with purged detailed evidence; association provenance remains separate.',
    'การเชื่อมจากเหตุการณ์มาก่อนความสัมพันธ์ตามเวลา LATEST_AVAILABLE คือประวัติเมื่อไม่มีเวลาล้มเหลว ไม่ยืนยันสาเหตุ EXPIRED คือคงรหัสแต่ล้างหลักฐานรายละเอียด และแสดงที่มาความสัมพันธ์แยก',
  ],
  meaning_history: [
    'Select one search, then one attempt and one offer within it using stable timestamp/ID ordering, at or before failure time when available. Search/offer current persisted states and response times are not a reconstructed state at failure.',
    'เลือกการค้นหาหนึ่งรายการ แล้วการประเมินและข้อเสนออย่างละรายการในนั้น ด้วยลำดับเวลา/รหัสที่คงที่ไม่เกินเวลาล้มเหลวถ้ามี สถานะและเวลาตอบที่บันทึกปัจจุบันไม่ใช่การสร้างสถานะ ณ เวลาล้มเหลวย้อนหลัง',
  ],
  meaning_scope: [
    'Current service areas mapped through the trip service group, not historical area membership. Multi-area mapping does not multiply trips or money.',
    'พื้นที่บริการปัจจุบันที่จับคู่ผ่านกลุ่มบริการของเที่ยว ไม่ใช่สมาชิกพื้นที่ในอดีต การจับคู่หลายพื้นที่ไม่เพิ่มจำนวนเที่ยวหรือเงิน',
  ],
  meaning_finance: [
    'Customer finance, never agent payout. MISSED billed/outstanding totals are zero; received amounts remain recorded even after refund. Unrefunded receipts or payments without fare can require finance review. Final total requires nonterminal settlement evidence and is unavailable here.',
    'การเงินลูกค้า ไม่ใช่ค่าตอบแทนพนักงาน MISSED มียอดเรียกเก็บและยอดค้างรวมศูนย์ แต่คงยอดรับแม้คืนเงินแล้ว ยอดรับไม่คืนหรือมีชำระแต่ไม่มีค่าโดยสารอาจต้องตรวจสอบ ยอดสุดท้ายต้องมีหลักฐานชำระของเที่ยวไม่สิ้นสุด จึงไม่มีในรายงานนี้',
  ],
  meaning_adjustment: [
    'Immutable booking quote is not reconstructed when absent. Adjustment is current persisted fare minus that quote, not final settlement or repricing.',
    'ไม่สร้างราคาประเมิน ณ การจองย้อนหลังเมื่อไม่มี ส่วนต่างคือค่าโดยสารปัจจุบันที่บันทึกลบราคาประเมินนั้น ไม่ใช่ยอดชำระสุดท้ายหรือการคิดราคาใหม่',
  ],
  source_trip: [
    'Persisted trip and booking identity/service times, with current provider master name. Service date uses scheduled start then created time.',
    'ข้อมูลเที่ยวบริการและการจองที่บันทึก พร้อมชื่อผู้ให้บริการปัจจุบัน วันบริการใช้เวลานัดเริ่มก่อนเวลาสร้าง',
  ],
  source_failure: [
    'Latest DISPATCH_FAILED ordered by event time and ID; dispatchFailedAt is fallback only. Event-linked search first, otherwise latest started search not after failure time. Attempts use computed time/revision/ID and offers offered time/ID within that search and not after failure time. Search/offer states and response times are current persisted facts, not reconstructed historical policy or cause. Without failure time, history is latest available only.',
    'DISPATCH_FAILED ล่าสุดตามเวลาและรหัสเหตุการณ์ ใช้ dispatchFailedAt เฉพาะเมื่อไม่มีเหตุการณ์ เลือกการค้นหาที่เชื่อมก่อน มิฉะนั้นเลือกการค้นหาล่าสุดที่เริ่มไม่เกินเวลาล้มเหลว การประเมินเรียงเวลาคำนวณ/รุ่น/รหัส และข้อเสนองานเรียงเวลาเสนอ/รหัสในค้นหานั้นไม่เกินเวลาล้มเหลว สถานะค้นหา/ข้อเสนอและเวลาตอบเป็นข้อมูลที่บันทึกปัจจุบัน ไม่สร้างนโยบายหรือสาเหตุย้อนหลัง เมื่อไม่มีเวลาล้มเหลวจะแสดงประวัติล่าสุดที่มีเท่านั้น',
  ],
  source_actor: [
    'Immutable actor type, ID and name from the failure event; current profile photo only. No current-name substitution.',
    'ประเภท รหัส และชื่อผู้กระทำจากเหตุการณ์ล้มเหลวซึ่งไม่แก้ย้อนหลัง เฉพาะภาพเป็นโปรไฟล์ปัจจุบัน ไม่แทนชื่อด้วยชื่อปัจจุบัน',
  ],
  source_current: [
    'Current passenger/assigned-agent/vehicle master details, persisted trip route and service group. Service areas are the CURRENT_SERVICE_GROUP mapping, not a historical booking snapshot; arrays align by sorted area ID.',
    'ข้อมูลหลักปัจจุบันของผู้โดยสาร/พนักงานที่ได้รับมอบหมาย/รถ เส้นทางและกลุ่มบริการของเที่ยวที่บันทึก พื้นที่บริการเป็นการจับคู่ CURRENT_SERVICE_GROUP ปัจจุบันไม่ใช่ภาพ ณ การจอง รายการรหัสและชื่อเรียงคู่กันตามรหัสพื้นที่',
  ],
  source_finance: [
    'Canonical persisted customer fare/quote and BASE/OVERAGE payment projection; no repricing or invented notional fare. MISSED billed/outstanding totals are zero; receipts remain recorded. Missing fare with payment and unrefunded receipts can require review. Final fare is unavailable on terminal trips. Fare sums exclude missing fares; missing-fare coverage is separate.',
    'การแปลงค่าโดยสาร/ราคาประเมินและชำระ BASE/OVERAGE ของลูกค้าที่บันทึกตามสัญญาหลัก ไม่คิดราคาใหม่หรือสร้างราคาสมมติ MISSED มียอดเรียกเก็บ/ค้างรวมเป็นศูนย์แต่คงยอดรับ ไม่มีค่าโดยสารแต่มีชำระหรือยอดรับยังไม่คืนอาจต้องตรวจสอบ ยอดค่าโดยสารสุดท้ายไม่มีในเที่ยวสิ้นสุด ผลรวมค่าโดยสารไม่รวมแถวไม่มีค่าและแสดงจำนวนที่ขาดแยก',
  ],
  empty_unavailable: [
    'Unavailable or not applicable in persisted evidence; never filled from current policy or inferred exhaustion time.',
    'ไม่มีข้อมูลหรือไม่เกี่ยวข้องตามหลักฐานที่บันทึก ไม่เติมจากนโยบายปัจจุบันหรือเดาเวลาจากการค้นหาจนครบ',
  ],
  empty_agentCode: [
    'Agent code is unavailable until a durable code exists; phone or UUID is not substituted.',
    'รหัสประจำตัวพนักงานยังไม่มีจนมีรหัสที่บันทึกจริง ไม่ใช้โทรศัพท์หรือ UUID แทน',
  ],
} as const;
type TranslationKey =
  | `missedServices_column_${keyof typeof columns}`
  | `missedServices_filter_${keyof typeof filters}`
  | `missedServices_summary_${keyof typeof summary}`
  | `missedServices_value_${keyof typeof values}`
  | `missedServices_${keyof typeof messages}`;
function translations(locale: 0 | 1): Record<TranslationKey, string> {
  const result: Partial<Record<TranslationKey, string>> = {};
  for (const [prefix, entries] of [
    ['column_', columns],
    ['filter_', filters],
    ['summary_', summary],
    ['value_', values],
    ['', messages],
  ] as const) {
    for (const [key, pair] of Object.entries(entries)) {
      result[`missedServices_${prefix}${key}` as TranslationKey] = pair[locale];
    }
  }
  // The same paired source generates both locales, so every key has TH/EN parity.
  return result as Record<TranslationKey, string>;
}
export const missedServicesTranslations = { en: translations(0), th: translations(1) } satisfies Record<
  'en' | 'th',
  Record<TranslationKey, string>
>;
